module.exports = __webpack_public_path__ + "img/aParty_110523_K.53f47c71.jpg";